import React from 'react';
import Box from '@material-ui/core/Box';
import { Slide, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
interface BoxProp {
    isOpen: boolean;
    width?: string;
    onClose: () => any;
}

const BoxSlideUI: React.FC<BoxProp> = ({ isOpen, width, onClose, children }) => {
    return (
        <Slide
            direction="left"
            mountOnEnter
            unmountOnExit
            in={isOpen}
        >
            <Box boxShadow={3}
                zIndex="modal"
                bgcolor="background.paper"
                position="absolute"
                borderRadius="4px"
                right="0.5%"
                bottom="1%"
                width={ width ? width : "65%"}
                height="98%"
                overflow="scroll"
                style=
                    {
                        { 
                            overflowX: 'hidden',
                            position: 'fixed'
                        }
                    }
                
            >
                <IconButton
                    style={
                        {
                            position: "absolute",
                            marginTop: "5px",
                            marginLeft: "10px"
                        }
                    }
                    onClick={onClose}
                >
                    <CloseIcon  style={{ fontSize: 25, color: '#597DDA' }} />
                </IconButton>

                {children}
            </Box>
        </Slide >
    );
};

export default BoxSlideUI;
